<template>
  <div class="medal-overlay">
    <van-overlay  v-for="(item, index) in arrDialogCon" :key="item.id" :show="item.isShowMedal">
      <div class="medal-wrap">
        <img v-if="`${item.medalLevel}` === '1'" src="@/assets/images/training/img(48).png" class="img-wrap2" alt="">
        <img v-if="`${item.medalLevel}` === '2'" src="@/assets/images/training/img(49).png" class="img-wrap2" alt="">
        <img v-if="`${item.medalLevel}` === '3'" src="@/assets/images/training/img(50).png" class="img-wrap2 mabtom" alt="">
        <img v-if="`${item.medalLevel}` === '4'" src="@/assets/images/training/img(51).png" class="img-wrap2 mabtom" alt="">
        <img v-if="`${item.medalLevel}` === '5'" src="@/assets/images/training/img(52).png" class="img-wrap2 mabtom" alt="">
        <img v-if="`${item.medalLevel}` === '2025'" src="@/assets/images/training/img(61).png" class="img-wrap2 mabtom" alt="">
        <div class="wrap-txt2" :class="`${item.medalLevel}` === '5' ? 'wrap-txt2-5' : ''" :style="{left: `${item.medalLevel}` === '2025' ? 'unset' : '22px',width: `${item.medalLevel}` === '2025' ? '100%' : ''}">
          <img src="@/assets/images/training/img(53).png" class="icon-left" alt="" v-if="`${item.medalLevel}` !== '2025'">
          <div class="txt" v-if="`${item.medalLevel}` === '1'">获得10积分</div>
          <div class="txt" v-if="`${item.medalLevel}` === '2'">获得20积分</div>
          <div class="txt" v-if="`${item.medalLevel}` === '3'">可任意解锁平台中3个<br/>上锁内容</div>
          <div class="txt" v-if="`${item.medalLevel}` === '4'">自动解锁平台上所有<br/>内容</div>
          <div class="txt" v-if="`${item.medalLevel}` === '5'">获得50积分</div>
          <div :class="['txt', `${item.medalLevel}` === '2025' ? 'text-box' : '']" v-if="`${item.medalLevel}` === '2025'">限定徽章</div>
        </div>
        <img src="@/assets/images/training/img(46).png" @click="handleClose(index)" class="icon-close" alt="">
      </div>
    </van-overlay>
  </div>
</template>
<script>
import { getMyMedalUpgrade, updateMedalIsShow } from '../../../api/person'
export default {
  data() {
    return {
      isShowMedal: false,
      arrDialogCon: []
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  mounted() {
    let params = {
      iepUserId: this.userInfo.id
    }
    getMyMedalUpgrade(params).then(res => {
      if (!res.data || res.data.length <= 0) return
      res.data.map(item => {
        item.isShowMedal = false
      })
      res.data[0].isShowMedal = true
      this.arrDialogCon = res.data
    })
  },
  methods: {
    handleClose(index) {
      updateMedalIsShow({id: this.arrDialogCon[index].id}).then(res => {
        this.arrDialogCon[index].isShowMedal = false
        if (index === this.arrDialogCon.length - 1) return
        this.arrDialogCon[index + 1].isShowMedal = true
      })
    }
  }
}
</script>
<style lang="less" scoped>
.medal-overlay {
  .medal-wrap {
    width: 280px;
    height: 420px;
    // background-image: url('../../../assets/images/training/img(31).png');
    // background-repeat: no-repeat;
    // background-size: 100% 100%;
    // padding: 0 24px;
    // padding-top: 26px;
    // box-sizing: border-box;
    position: fixed;
    z-index: 99;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .wrap-txt1 {
      text-align: center;
      color: #000000;
      font-size: 22px;
      line-height: 31px;
      font-weight: 500;
      margin-bottom: 22px;
    }
    .img-wrap2 {
      width: 280px;
      height: 420px;
      position: absolute;
      left: 0;
      top: 0;
      display: block;
      margin-bottom: 32px;
      margin-left: 50%;
      transform: translateX(-50%);
      // &.mabtom {
      //   margin-bottom: 16px;
      // }
    }
    .wrap-txt2 {
      text-align: center;
      color: #000000;
      font-size: 22px;
      line-height: 32px;
      font-weight: 500;
      font-family: Source Han Sans CN, Source Han Sans CN;
      position: absolute;
      top: 343px;
      left: 22px;
      display: flex;
      &.wrap-txt2-5 {
        top: 366px;
      }
      .icon-left {
        width: 52px;
        height: 28px;
        display: block;
        margin-right: 5px;
      }
      .txt {
        display: block;
        flex: 1;
        line-height: 28px;
        font-size: 18px;
        color: #696969;
      }
      .text-box {
        font-size: 22px;
        color: #000;
      }
    }
    .icon-close {
      width: 32px;
      height: 32px;
      position: absolute;
      bottom: -48px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/person/components/medalOverlay.vue